import React from "react";

const PrivacyContent = () => {
  return (
    <section className="py-16 bg-cloud-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <div className="mb-8">
                <p className="text-gray-700 leading-relaxed mb-6">
                  Cittasya Wellness (OPC) Private Limited (which are
                  collectively referred to as the "Cittasya®", "Company", "we",
                  "us" or "our") collects and processes the information you
                  provide in connection with your use of the Cittasya® Mobile
                  App, the website www.cittasya.com, and its other digital
                  platforms (collectively referred to as "Platform"). We value
                  your privacy and take the responsibility in relation to your
                  data seriously.
                </p>
                <p className="text-gray-700 leading-relaxed mb-6">
                  This Privacy Policy ("Privacy Policy") is published in
                  compliance with:
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  <strong>I. For Indian Residents</strong>
                </p>
                <div className="ml-6 mb-4">
                  <p className="text-gray-700 leading-relaxed mb-2">
                    i. Section 43A of the Information Technology Act, 2000 ("IT
                    Act");
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    ii. Rule 4 of the Information Technology (Reasonable
                    Security Practices and Procedures and Sensitive Personal
                    Data or Information) Rules, 2011 ("SPDI Rules"); and
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    iii. Rule 3(1) of the Information Technology (Intermediaries
                    Guidelines) Rules, 2011.
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed mb-4">
                  <strong>II. For Non-Indian Residents</strong>
                </p>
                <div className="ml-6 mb-6">
                  <p className="text-gray-700 leading-relaxed mb-2">
                    i. The EU General Data Protection Regulation
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    ii. EU-US and Swiss-US Privacy Shield Frameworks
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed mb-6">
                  This Privacy Policy deals with information we collect in
                  relation to our platform. The policy is in compliance with
                  both Indian as well as non-Indian laws mentioned above, and
                  serves as a uniform framework for all the users, irrespective
                  of their residence. The Privacy Policy, in principle, covers:
                </p>
                <div className="ml-6 mb-8">
                  <p className="text-gray-700 leading-relaxed mb-2">
                    a) What information we collect;
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    b) How we collect and use that information;
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    c) How you can provide information selectively, and how you
                    can access and update this information; and
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    d) How we process, share and protect your information.
                  </p>
                </div>
              </div>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                1. General
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                1.1. The platform is owned and managed by Cittasya® and provides
                yogic wellness practices. This Privacy Policy applies to all
                current and former users accessing or using the platform, or
                otherwise engaging with us through email or other means.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                1.2. The collection and processing of information in the course
                of our delivery of services, or other contractual or commercial
                engagements that we may enter into, will be done in accordance
                with the specific terms applicable thereto, and not by this
                Privacy Policy.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                1.3. By accessing or using our platform or by otherwise giving
                us your information, you confirm that you have the capacity to
                enter into a legally binding contract and have read, understood
                and agreed to the practices and policies outlined in this
                Privacy Policy.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                1.4. You hereby consent to our collection, use, sharing, and
                disclosure of your information as described in this Privacy
                Policy.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                1.5. We may modify, add or delete from, this Privacy Policy from
                time to time, and your continued access to, or use of the
                platform, will be deemed to be an acceptance of the said
                changes. If you do not agree with this Privacy Policy at any
                time, in part or as a whole, do not access/use the platform or
                services provided through the platform, or provide us with any
                of your information.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                2. Information Collected and Method of Collection
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.1. We collect the following types of information about you,
                both through offline documentation as well as when you use our
                platform: User Information, Demographic Information, Behavioural
                Information, and Indirect Information, (each of which have been
                defined below, and collectively, "Information").
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.2. We collect your information either directly from you
                through offline documentation and/or platform by using different
                technologies.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.3. In order to access the platform, you may be required to
                provide us with information in the nature of your name, email
                address, mobile number, the company/ organization you work for,
                title, designation, physical addresses (collectively, "User
                Information").
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.4. We may also collect your information when you visit any of
                our office or attend any seminars, webinars, conferences or
                events organised by Us.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.5. We may collect from you, information which is not unique to
                you and refers to selected population characteristics
                ("Demographic Information") including age, gender and current
                location details.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.6. We may also collect information about how you use the
                platform and information about your mobile device and software
                including usage statistics, traffic data, your IP address,
                browser and operating system type, domain names, access times,
                locations, and details regarding the parts of the platform that
                you access ("Behavioural Information").
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.7. Your use of certain third-party services on the platform
                also requires us to collect such information as is considered
                necessary for that purpose ("Indirect Information").
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.8. We may collect information about your activities outside of
                the platform, including information about your device, websites
                you visit, purchases you make, the adverts you see and how you
                use their services ("Cookies"). This information is collected
                from various third parties we work with such as advertisers,
                vendors, service providers, developers, third parties whose APIs
                are integrated with our services.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.9. While we may collect Demographic Information, Behavioural
                Information and Indirect Information when you access or use our
                platform, we collect User Information and Cookies only from you
                with your prior consent unless there are other legal grounds for
                doing so, as further specified in this Privacy Policy. Where you
                provide us with User Information of third parties, we understand
                that you have obtained consent of such third parties, and have
                sufficient rights, approvals and licenses to provide such
                information to us.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.10. The IT Act and the SPDI Rules regulate the collection,
                usage, retention and disclosure of personal information, which
                is defined under the SPDI Rules as any information that relates
                to a natural person, which, either directly or indirectly, in
                combination with other information available or likely to be
                available to a body corporate, is capable of identifying such
                person ("Personal Information").
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.11. Some of the information collected by us may qualify as
                Personal Information.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.12. We understand that all Personal Information provided by
                you to us is voluntary. The collection, use and disclosure of
                Personal Information requires your express consent, unless there
                are other legal grounds available to us to collect such
                information as further specified in this Privacy Policy. By
                using or accessing the platform or otherwise providing us with
                your Personal Information, where applicable, you are providing
                us with your consent to our use, collection, retention, transfer
                and disclosure of the Personal Information in accordance with
                the terms of this Privacy Policy.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                2.13. In the event of a change in the law applicable to data
                protection in India, you hereby expressly consent to our
                continued use, storage, collection and disclosure of your
                information including Personal Information to the fullest extent
                permitted under such applicable law. We may reach out to You for
                obtaining additional consents and approvals as required under
                the amended law and you will be required to comply with such
                requests. Should You choose to not provide us with such
                additional consents and approvals, we may have to discontinue
                your access to the platform.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                2.14. You may choose to not provide us with or withdraw any or
                all information included under Personal Information, but in the
                event that you do so, we may be unable to allow you to access
                the platform or otherwise avail services for the provision of
                which your information is being collected or processed.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                3. Use of Information
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                3.1. We use your information for the following purposes:
              </p>
              <div className="ml-6 mb-4">
                <p className="text-gray-700 leading-relaxed mb-2">
                  a) To operate and improve the platform in order to foster a
                  positive user experience and to improve our business as a
                  whole;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  b) Analysing data, tracking trends, building algorithms,
                  creating databases for rating systems, recommendations
                  engines, etc.;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  c) Research and analysis;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  d) For non-targeting reasons such as frequency capping,
                  compliance, information reporting or delivery, market research
                  or product development purposes;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  e) To conduct audits and quality assessment procedures;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  f) To analyse the use of our resources and troubleshooting
                  problems in relation to our platform.
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  g) Send you marketing communications and newsletters;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  h) Display content based upon your interests and personalize
                  the content and advertising you receive; and
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  i) Offer other products, features, or services that may be of
                  interest to you.
                </p>
              </div>
              <p className="mb-4 text-gray-700 leading-relaxed">
                3.2. In addition to the above, we also use your information,
                including Personal Information, for the following purposes:
              </p>
              <div className="ml-6 mb-4">
                <p className="text-gray-700 leading-relaxed mb-2">
                  a) For our internal operational purpose such as record
                  keeping, accounting and compliance with applicable taxation
                  laws;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  b) For the purposes of recording information including dates
                  times and locations at which our platform has been accessed by
                  using various tracking technologies and thereby improve our
                  platform and your experience by providing you with relevant
                  information based on the above. Your disabling of tracking
                  technologies on the platform by changing settings on your
                  smartphone and/or web browser may result in your inability to
                  use the platform fully or at all;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  c) To invite you for seminars, webinars and workshops
                  conducted by us which we believe may be of interest to You;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  d) To comply with applicable law;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  e) To investigate, prevent, or take action regarding illegal
                  activities, suspected fraud, situations involving potential
                  threats to the safety of any person, or as otherwise required
                  by law;
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  f) To respond to any queries that you may have, and to
                  communicate information to you, including notifications of any
                  alerts, any updates to the platform; and
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  g) To contact you from time to time to record your valuable
                  feedback on our platform, as they currently stand, and/or any
                  potential services that may be ordered in the future;
                  (Collectively, the above constitute "the Purposes").
                </p>
              </div>
              <p className="mb-4 text-gray-700 leading-relaxed">
                3.3. If you wish to opt out of receiving communications such as
                information regarding the services, you may do so by emailing us
                at support@cittasya.com.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                3.4. Further, we may use social media platform such as LinkedIn,
                Twitter and Facebook. If You connect with us through any of
                these services, then such engagement will be subject to the
                terms of service and privacy policy of the relevant social media
                platform and you should review the same before connecting with
                us on such social media platform.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                3.5. Our processing of your Personal Information in the context
                of your visit to, and use of our platform are based on our
                legitimate interests to operate an internet website and blogs
                for general information and communication purposes, to optimize
                our website and blogs, and to protect it from attacks.
                Furthermore, our processing of your Personal Information for
                conducting other business development activities serves the
                legitimate interests of the users to receive training for their
                wellbeing and serves our legitimate interests to develop our
                business and promote client relationships.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                4. Disclosure of the Information
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                4.1. We disclose your Information including Personal
                Information, as the case may be to third parties in the manner
                specified below:
              </p>
              <div className="ml-6 mb-4">
                <p className="text-gray-700 leading-relaxed mb-4">
                  a) Disclosing your information including Personal Information
                  to companies and individuals who are acting as our
                  counterparties, consultants and advisors in relation to the
                  platform;
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  b) Disclosing your information including Personal Information
                  to companies and individuals who are authorised by us to
                  perform certain functions in relation to the platform and/or
                  our business, including our third-party service providers,
                  consultants and professional advisors and insurers;
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  c) We also share aggregated information about you with
                  partners, other Platform users, and other third parties for
                  the purpose of improving our platform;
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Such third parties may include: any of our agents, contractors
                  or third party service providers that process or will be
                  processing your information, on our behalf, including but not
                  limited to those which provide administrative or other
                  services to us such as mailing houses, telecommunication
                  companies, information technology companies and data centres;
                  and third parties, such as service providers, to whom
                  disclosure by us is for one or more of the purposes and such
                  third parties would in turn be collecting and processing your
                  information including Personal Information for one or more of
                  the purposes.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  d) We may transfer information including Personal Information
                  to third parties, including persons outside India, in
                  furtherance of the above; and
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  e) We may disclose your information, including Personal
                  Information, if legally required to do so, pursuant to an
                  order from a governmental entity or in good faith.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                5. Third Party Links
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                5.1. The Platform may contain links to third party websites and
                services ("Third Party Services"). We have no control over such
                Third-Party Services, which are provided by persons or companies
                other than us. We are not responsible for any collection or
                disclosure of your information by such companies or persons
                thereof. For instance, we have partnered with a payment gateway
                for financial services, and they may collect your financial
                information in accordance with their privacy policy. We do not
                have access to such information provided to third parties.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                5.2. Further, we are not liable for any loss or damage which may
                be incurred by you as a result of the collection and/or
                disclosure of your information via Third Party Services. We
                shall not be liable for any disputes arising from or in
                connection with such transactions between you and any third
                parties.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                5.3. Third party websites, and external applications or
                resources, accessible via the platform may have their own
                privacy policies governing the collection, storage, transfer,
                retention and/or disclosure of your information that you may be
                subject to. The user is advised to read their privacy policy and
                make an informed decision.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                6. Changes to Your Information
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                6.1. You may review, correct, update, or change your Personal
                Information on the platform by emailing us at
                support@cittasya.com.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                6.2. You may also request us to delete your Personal
                Information, and we will comply with such requests within a
                reasonable time, unless we are required to keep certain
                information for legal purposes.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                6.3. Should you choose to delete your Personal Information, or
                modify it in a way that is not verifiable by us, or leads to
                such Personal Information being incorrect, we will be unable to
                provide you with access to our platform, and such a deletion or
                modification may be regarded as the user seeking to discontinue
                access to our platform.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                6.4. We reserve the right to verify and authenticate your
                identity and your Personal Information in order to ensure
                accurate delivery of services through the Platform.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                6.5. Access to, or correction, updating or deletion of your
                Personal Information may be denied or limited by us if it would
                violate another person's rights and/or is not otherwise
                permitted by applicable law.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                7. Security of Your Information
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                7.1. We endeavour to maintain physical, technical and procedural
                safeguards that are appropriate to protect your Information
                against loss, misuse, copying, damage or modification and
                unauthorized access or disclosure. Some of the security measures
                adopted by us are:
              </p>
              <div className="ml-6 mb-4">
                <p className="text-gray-700 leading-relaxed mb-2">
                  a) We review our information collection, storage and
                  processing practices, including physical security measures, to
                  guard against unauthorized access to systems; and
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  b) We restrict access to Personal Information, to our
                  employees, agents and service providers who need to know that
                  information in order to process it for us, and who are subject
                  to strict contractual confidentiality obligations, and who may
                  be disciplined or whose relationship with us may terminate, if
                  they fail to meet these obligations.
                </p>
              </div>
              <p className="mb-8 text-gray-700 leading-relaxed">
                7.2. Further, we shall not be responsible for any breach of
                security or for any actions of any third parties or events that
                are beyond our reasonable control including but not limited to
                acts of government, computer hacking, unauthorised access to
                computer data and storage device, computer crashes, breach of
                security and encryption, etc.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                8. Retention of Information
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                8.1. We will put in place measures such that your Personal
                Information, which is in our possession or under our control, is
                destroyed and/or anonymized as soon as and in any case, within 5
                (five) years of it being reasonable to assume that (i) the
                purpose for which that Personal Information was collected is no
                longer being served by the retention of such Personal
                Information; and (ii) retention is no longer necessary for any
                other reason including applicable law.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                8.2. If you wish that we no longer use your Personal Information
                in accordance with the terms of this Privacy Policy, contact us
                at support@cittasya.com.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                8.3. We, however, reserve the right to retain, store and use
                your information including Personal Information for our business
                purposes, whether such information has been deleted or not.
                After a period of time, your data may be anonymized and
                aggregated, and then may be held by us as long as necessary for
                us to provide our services effectively.
              </p>
              <p className="mb-8 text-gray-700 leading-relaxed">
                8.4. Please note that your withdrawal of consent to use your
                Personal Information may result in us not being able to provide
                you with access to the platform, or terminate any existing
                relationship that we may have with you.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                Disclaimer
              </h2>
              <p className="mb-8 text-gray-700 leading-relaxed">
                We cannot ensure that all of your information including Personal
                Information will never be disclosed in ways not otherwise
                described in this Privacy Policy. Therefore, although we are
                committed to protecting your privacy, we do not promise, and you
                should not expect, that your information or private
                communications will always remain private. As a user of the
                platform, you assume all responsibility and risk for your use of
                the platform, the internet generally, and the information you
                post or access and for your conduct on and off the platform.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                Indemnity
              </h2>
              <p className="mb-8 text-gray-700 leading-relaxed">
                You agree and undertake to indemnify us in any suit or dispute
                by any third party arising out of disclosure of information by
                you to third parties either through our platform or otherwise,
                and your use and access of websites, applications and resources
                of third parties. We assume no liability for any actions of
                third parties with regard to your information or Personal
                Information which you may have disclosed to such third parties.
              </p>

              <h2 className="text-2xl font-bold text-forest-green mb-6">
                Grievance Officer and Information
              </h2>
              <p className="mb-4 text-gray-700 leading-relaxed">
                N. Mishra is the Grievance Officer and you may reach out at
                support@cittasya.com.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyContent;
